import * as actionTypes from './actionTypes';

export const fetching = ( show_globalSpinner ) => {
    return {
        type: actionTypes.FETCHING,
        show_globalSpinner: show_globalSpinner
    };
};

export const not_fetching = () => {
    return {
        type: actionTypes.NOT_FETCHING
    };
};

export const fetchingStart = (show_globalSpinner) => {
	return dispatch => {
	    dispatch(fetching( show_globalSpinner ));
	};
};

export const fetchingStop = () => {
    return dispatch => {
	    dispatch(not_fetching());
	}
};


// WEBPACK FOOTER //
// ./src/_store/actions/fetching.js